import * as React from 'react';
import * as autoBind from 'react-autobind';
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper';
import AvatarStack from '../AvatarStack/AvatarStack';
import Constants, {ModalStates} from '../../globals/Constants';
import ReviewModel from '../../types/ReviewModel';
import UsersModel from '../../types/UsersModel';
import ReviewerModel from '../../types/ReviewerModel';
import UserModel from '../../types/UserModel';

const MAX_NUMBER_OF_AVATARS_TO_DISPLAY = 7;

export default class ReviewerDisplay extends React.Component<ReviewerDisplayProps, {}> {
   constructor(props: ReviewerDisplayProps) {
      super(props);
      autoBind(this);
   }

   clickDisplayReviewers() {
      this.props.setModalState(ModalStates.manageReviewers);
   }

   getUsersToDisplay(reviewers: ReviewerModel[]): string[] {
      let userIds: string[] = [];

      if (reviewers) {
         userIds = reviewers.filter(reviewer => !reviewer.WasUserRoleRemoved).map(reviewer => reviewer.Id).filter(id => this.props.users[id]);
         userIds = [...new Set(userIds)];
      }

      return userIds;
   }

   getAvatar(user: UserModel) {
      const isOwner = this.props.review.Reviewers.some(r => r.Id === user.userId && r.Role === Constants.reviewerRoles.owner);
      return <AvatarWrapper key={user.userId} user={user} isOwner={isOwner}/>;
   }

   render() {
      const {review, users, numberAvatarsDisplayed} = this.props;
      const userIds = this.getUsersToDisplay(review.Reviewers);
      const avatarsDisplayed = numberAvatarsDisplayed ? numberAvatarsDisplayed : MAX_NUMBER_OF_AVATARS_TO_DISPLAY;
      const usersToDisplay = userIds.slice(0, avatarsDisplayed);
      const usersToHide = userIds.slice(avatarsDisplayed);

      return (
         <div className="review-members">
            {usersToDisplay.map(user => this.getAvatar(users[user]))}
            {usersToHide.length > 0 && <div className="avatar" onClick={this.clickDisplayReviewers}>
               <AvatarStack numberReviewers={usersToHide.length}/>
            </div>}
         </div>
      );
   }
}

export interface ReviewerDisplayProps {
   review: ReviewModel;
   users: UsersModel;
   numberAvatarsDisplayed?: number;
   setModalState(modalState: ModalStates): void;
}
